import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
	server: {
		FF_KEY: z.string(),
		NEXT_PREVIEW_TOKEN: z.string(),
		CENTRA_API_SECRET: z.string(),
		CENTRA_INTEGRATION_TOKEN: z.string(),
		CENTRA_INTEGRATION_URL: z.string().url(),
		STORYBLOK_ACCESS_TOKEN_PREVIEW: z.string(),
		SHOWROOM_API_URL: z.string().min(1),
		SHOWROOM_JWT_SECRET: z.string().min(1),
		CLOUDINARY_NAME: z.string().min(1),
		CLOUDINARY_API_KEY: z.string().min(1),
		CLOUDINARY_API_SECRET: z.string().min(1),
		CRON_SECRET: z.string().min(1),
		REVALIDATE_SECRET: z.string().min(1),
		RAUMAGARN_KV_REST_API_URL: z.string().url(),
		RAUMAGARN_KV_REST_API_TOKEN: z.string().min(1),
	},
	client: {
		NEXT_PUBLIC_ALGOLIA_ANALYTICS_API_KEY: z.string().min(1),
		NEXT_PUBLIC_STORYBLOK_TOKEN: z.string(),
		NEXT_PUBLIC_CENTRA_CHECKOUT: z.string(),
		NEXT_PUBLIC_R2_PUBLIC_URL: z.string().min(1),
		NEXT_PUBLIC_INGRID_SITE_ID: z.string(),
		NEXT_PUBLIC_INGRID_API_URL: z.string().min(1),
		NEXT_PUBLIC_LOGTAIL_SOURCE_TOKEN: z.string().min(1),
		NEXT_PUBLIC_ALGOLIA_APP_ID: z.string().min(1),
		NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY: z.string().min(1),
		NEXT_PUBLIC_FREND_ADDRESS_KEY: z.string().min(1),
		NEXT_PUBLIC_GTM_ID: z.string().min(1),
	},
	runtimeEnv: {
		FF_KEY: process.env.FF_KEY,
		NEXT_PREVIEW_TOKEN: process.env.NEXT_PREVIEW_TOKEN,
		CENTRA_API_SECRET: process.env.CENTRA_API_SECRET,
		CENTRA_INTEGRATION_TOKEN: process.env.CENTRA_INTEGRATION_TOKEN,
		CENTRA_INTEGRATION_URL: process.env.CENTRA_INTEGRATION_URL,
		NEXT_PUBLIC_STORYBLOK_TOKEN: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN,
		NEXT_PUBLIC_CENTRA_CHECKOUT: process.env.NEXT_PUBLIC_CENTRA_CHECKOUT,
		NEXT_PUBLIC_R2_PUBLIC_URL: process.env.NEXT_PUBLIC_R2_PUBLIC_URL,
		STORYBLOK_ACCESS_TOKEN_PREVIEW: process.env.STORYBLOK_ACCESS_TOKEN_PREVIEW,
		SHOWROOM_API_URL: process.env.SHOWROOM_API_URL,
		SHOWROOM_JWT_SECRET: process.env.SHOWROOM_JWT_SECRET,
		CRON_SECRET: process.env.CRON_SECRET,
		CLOUDINARY_NAME: process.env.CLOUDINARY_NAME,
		CLOUDINARY_API_KEY: process.env.CLOUDINARY_API_KEY,
		CLOUDINARY_API_SECRET: process.env.CLOUDINARY_API_SECRET,
		NEXT_PUBLIC_INGRID_SITE_ID: process.env.NEXT_PUBLIC_INGRID_SITE_ID,
		NEXT_PUBLIC_INGRID_API_URL: process.env.NEXT_PUBLIC_INGRID_API_URL,
		NEXT_PUBLIC_LOGTAIL_SOURCE_TOKEN: process.env.NEXT_PUBLIC_LOGTAIL_SOURCE_TOKEN,
		NEXT_PUBLIC_ALGOLIA_APP_ID: process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
		NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY,
		NEXT_PUBLIC_ALGOLIA_ANALYTICS_API_KEY: process.env.NEXT_PUBLIC_ALGOLIA_ANALYTICS_API_KEY,
		REVALIDATE_SECRET: process.env.REVALIDATE_SECRET,
		RAUMAGARN_KV_REST_API_URL: process.env.RAUMAGARN_KV_REST_API_URL,
		RAUMAGARN_KV_REST_API_TOKEN: process.env.RAUMAGARN_KV_REST_API_TOKEN,
		NEXT_PUBLIC_FREND_ADDRESS_KEY: process.env.NEXT_PUBLIC_FREND_ADDRESS_KEY,
		NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
	},
});
